import { render, staticRenderFns } from "./FooterNavigationIr.vue?vue&type=template&id=dd34e406"
import script from "./FooterNavigationIr.vue?vue&type=script&lang=js"
export * from "./FooterNavigationIr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports